import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

import toast from "react-hot-toast";
import Select from "react-select";
import ServiceModule from "../../../services/KangarooServices/ServiceModule";
import WidgetService from "../../../services/KangarooServices/Intelligence/WidgetService";
import ServiceIntellWidgets from "../../../services/KangarooServices/Intelligence/ServiceIntellWidgets";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";

const ServiceWidgetForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ ServiceWidgetForm ~ selectedItem:", selectedItem);
  const [serviceData, setServiceData] = useState([]);
  const [widgetData, setWidgetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const authUser = getLoggedInUser();
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;

  const fetchWidgetData = async (page = 1, size = 1000) => {
    try {
      const response = await WidgetService.getList({
        isOnshore: isOnshorePage,
        page,
        pageSize: size,
      });
      setWidgetData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServiceData = async () => {
    setLoading(true);
    try {
      const response = await ServiceModule.getList();
      setServiceData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWidgetData();
    fetchServiceData();
  }, []);

  const formik = useFormik({
    initialValues: {
      servicesIds: selectedItem?.serviceId
        ? [String(selectedItem.serviceId)]
        : [],

      widgetIds: Array.isArray(selectedItem?.widgets)
        ? selectedItem.widgets.map((w) => String(w.widgetId))
        : [],
    },

    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      try {
        if (selectedItem?.serviceId) {
          const payload = {
            // servicesId: values.servicesIds,
            widgetIds: values.widgetIds,
          };

          await ServiceIntellWidgets.update(selectedItem.serviceId, payload);
          toast.success("Service-Widget updated successfully");
        } else {
          const payload = {
            servicesIds: values.servicesIds,
            widgetIds: values.widgetIds,
          };

          await ServiceIntellWidgets.create(payload);
          toast.success("Service-Widget created successfully");
        }

        resetForm();
        fetchData();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!");
      }
    },
  });

  const serviceOptions = serviceData.map((service) => ({
    value: String(service.id),
    label: service.name,
  }));

  // const widgetOptions = widgetData?.map((widget) => ({
  //   value: String(widget.id),
  //   label: widget.name,
  // })); 
  const widgetOptions = [
    ...widgetData?.map((type) => ({
      value: type.id,
      label: type.name,
    })),
    ...(selectedItem?.widgets?.map((w) => ({
      value: w.id,
      label: w.name,
    })) || []),
  ];
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {selectedItem?.serviceId
          ? "Edit Service-Widget Mapping"
          : "Create Service-Widget "}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          {!selectedItem?.serviceId && (
            <div className="mb-3">
              <Label>Services</Label>
              <Select
                isMulti
                options={serviceOptions}
                value={serviceOptions.filter((opt) =>
                  formik.values.servicesIds.includes(opt.value),
                )}
                onChange={(selected) =>
                  formik.setFieldValue(
                    "servicesIds",
                    selected ? selected.map((s) => s.value) : [],
                  )
                }
                placeholder="Select services"
                isLoading={loading}
              />
            </div>
          )}
          <div className="mb-3">
            <Label>Widget</Label>
            <Select
              isMulti
              options={widgetOptions}
              // value={widgetOptions.filter((opt) =>
              //   formik.values.widgetIds.includes(opt.value),
              // )}
              value={
                formik.values.widgetIds
                  .map((id) => widgetOptions.find((opt) => opt.value === id))
                  .filter(Boolean) // just in case some IDs are missing
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "widgetIds",
                  selected ? selected.map((s) => s.value) : [],
                )
              }
              placeholder="Select widget"
            />
          </div>

          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.serviceId ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default ServiceWidgetForm;
